import React from 'react'
import './SMSModalCard.css'
import Spinner from 'react-bootstrap/Spinner';


type Props = {
    SMSConfirm: boolean | undefined,
    SMSResponseLoading: boolean
}

const SMSModalCard: React.FC<Props> = ({ SMSConfirm, SMSResponseLoading }) => {
  return (
    <div className='sms-modal-card'>
        <div className='card card-content'>
            {SMSResponseLoading && (<>
                <Spinner animation="border" role='status' style={{width: '4rem', height: '4rem'}}/>
            </>)}
            {(SMSResponseLoading === false) && (SMSConfirm ? (<>
              <div className="swal2-icon swal2-success swal2-animate-success-icon" style={{display: 'flex'}}>
                  <div className="swal2-success-circular-line-left" style={{backgroundColor: 'rgb(255, 255, 255)'}}></div>
                  <span className="swal2-success-line-tip"></span>
                  <span className="swal2-success-line-long"></span>
                  <div className="swal2-success-ring"></div> 
                  <div className="swal2-success-fix" style={{backgroundColor: 'rgb(255, 255, 255)'}}></div>
                  <div className="swal2-success-circular-line-right" style={{backgroundColor: 'rgb(255, 255, 255)'}}></div>
              </div>
              <h1>SMS Gönderildi</h1>
            </>) : (<>
              <div className="swal2-icon swal2-error swal2-animate-error-icon" style={{display: 'flex'}}>
                  <span className="swal2-x-mark">
                      <span className="swal2-x-mark-line-left"></span>
                      <span className="swal2-x-mark-line-right"></span>
                  </span>
              </div>
              <h1>SMS Gönderilemedi</h1>
            </>))}
        </div>
    </div>
  )
}

export default SMSModalCard
